<script>
  import Toast from '$lib/components/Toast.svelte';
  import { flip } from 'svelte/animate';
  import { fly } from 'svelte/transition';
  import { toasts } from '../modals';
</script>

{#if $toasts && $toasts.length > 0}
  <div class="fixed right-4 top-4 z-[1100] space-y-2">
    {#each $toasts as { id, message, type } (id)}
      <div transition:fly animate:flip>
        <Toast {id} {message} {type} />
      </div>
    {/each}
  </div>
{/if}
